import React from "react";
import { Box } from "@mui/material";

// Floating-label field matching reno-portal's design-scope `Field`
// component (label sits on the top border, 52px rounded input).
const inputBaseStyle = {
    width: "100%",
    borderRadius: "12px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
    color: "#0d0d0e",
    fontFamily: "Inter Tight",
    backgroundColor: "#fff",
    outline: "none",
    boxSizing: "border-box",
};

export default function FloatingField({
    label,
    value,
    onChange,
    type = "text",
    placeholder = "",
    multiline = false,
    rows = 3,
    disabled = false,
    inputProps = {},
    error = false,
}) {
    const borderColor = error ? "#f87171" : "#d1d5db";

    return (
        <Box sx={{ position: "relative", width: "100%" }}>
            {label && (
                <Box
                    component="label"
                    sx={{
                        position: "absolute",
                        left: "14px",
                        top: "-8px",
                        fontSize: "12px",
                        color: "#949daa",
                        backgroundColor: "#fff",
                        padding: "0 4px",
                        zIndex: 1,
                        fontFamily: "Inter Tight",
                        lineHeight: "16px",
                    }}
                >
                    {label}
                </Box>
            )}
            {multiline ? (
                <textarea
                    value={value ?? ""}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    rows={rows}
                    style={{
                        ...inputBaseStyle,
                        borderColor,
                        padding: "14px 16px",
                        resize: "vertical",
                        backgroundColor: disabled ? "#f9fafb" : "#fff",
                        cursor: disabled ? "not-allowed" : "text",
                    }}
                />
            ) : (
                <input
                    type={type}
                    value={value ?? ""}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    {...inputProps}
                    style={{
                        ...inputBaseStyle,
                        borderColor,
                        height: "52px",
                        padding: "0 16px",
                        backgroundColor: disabled ? "#f9fafb" : "#fff",
                        cursor: disabled ? "not-allowed" : "text",
                        ...(inputProps.style || {}),
                    }}
                />
            )}
        </Box>
    );
}
